import React from 'react';

const CustomHeader = () => (
    <div style={{ textAlign: 'center' }}>
      <strong>Ventas por Cuenta Propia</strong>
    </div>
  );
  
export const columnsTable = () => [
    {
      name: 'Día',
      selector: row => row.dia,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Del No.',
      selector: row => row.delNo,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Al No.',
      selector: row => row.alNo,
      sortable: true,
      width: '100px',
    },
    {
      name: 'No. Máquina o Caja Registradora',
      selector: row => row.maquina,
      sortable: true,
      width: '270px',
    },
    {
      name: 'Ventas No Sujetas',
      selector: row => row.noSujetas,
      sortable: true,
      width: '220px',
    },
    {
      name: 'Ventas Exentas',
      selector: row => row.exentas,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Ventas Gravadas Locales',
      selector: row => row.gravadas,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Exportaciones',
      selector: row => row.exportaciones,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Ventas Totales',
      selector: row => row.ventasTotales,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Ventas por Cuenta de Terceros',
      selector: row => row.terceros,
      sortable: true,
      width: '250px',
    },
    {
      name: '1% Retencion',
      selector: row => row.retencion,
      sortable: true,
      width: '150px',
    }
  ];